// (C) Copyright 2017-2024 Hewlett Packard Enterprise Development LP
import { startCase } from 'lodash'

import { get } from '../../../utils/api-utils'

export const ldFlagsStatusPaginate = (array, pageSize, pageNumber) => {
  return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
}

export const ldFlagsStatusSearch = (targetStr, data) => {
  if (targetStr?.length > 0) {
    return data.filter((item) => {
      return item?.key?.includes(targetStr)
    })
  }
  return data
}

export const getEnvFilteredData = (inputData, headerFilter) => {
  const envKey = Object.keys(headerFilter)[0]
  if (envKey && headerFilter[envKey] !== 0) {
    const inputStatus =
      headerFilter[envKey] === 1 || headerFilter[envKey] === 3 ? 'ON' : 'OFF'
    const dataFilteredByStatus = inputData.filter((el) => {
      return el[envKey]?.status === inputStatus
    })
    if (headerFilter[envKey] === 3 || headerFilter[envKey] === 4) {
      return dataFilteredByStatus.filter((el) => {
        return el[envKey]?.hasRules
      })
    }
    return dataFilteredByStatus
  }
  return inputData
}

export const ldFlagsStatusLang = {
  title: 'Feature Flags',
  key: 'Feature Flag Key',
  table_summary: 'Feature Flag Keys',
  search_placeholder: 'Search Feature Flag Key',
  ON: 'ON',
  OFF: 'OFF',
  ALL: 'All',
  on_rules: 'ON(Rules)',
  off_rules: 'OFF(Rules)',
  details_last_modified: 'Last Modified:',
  details_variations: 'Variations:',
  targetOn: 'Target On:',
  targetOff: 'Target Off:',
  rules: '(Rules)'
}

export const ldFlagsEnvs = {
  'glcp-production': 'env_prod',
  'glcp-stage': 'env_pavo',
  'glcp-pre-prod': 'env_dracomr',
  'glcp-qa': 'env_mira',
  'glcp-dev-integration': 'env_triton',
  'glcp-dev': 'env_dev',
  'glcp-hotfix': 'env_hotfix'
}

export const variationTypes = ['targetOn', 'targetOff']
const isCypressTesting = !!window.Cypress

const testOnlyMainAPI = '/test-only/flags/greenlake-platform/main'
const testOnlyRowAPI = '/test-only/flags/greenlake-platform/row'
const uiDoorWayEndpoint = '/ui-doorway/ui/v2/ld-flags-status'

export const getAllLDEnvData = (token) => {
  return get(isCypressTesting ? testOnlyMainAPI : uiDoorWayEndpoint, {}, token)
}

export const getLDDetailsPerFlag = (flag, access_token) => {
  const perFlagAPI = isCypressTesting
    ? `${testOnlyRowAPI}?flag=${flag}`
    : `${uiDoorWayEndpoint}/${flag}`
  return get(perFlagAPI, {}, access_token)
}

export const envDisplayNameConversion = (inputString) => {
  if (inputString?.length > 0) {
    const inputStringArr = inputString.trim().split(' ')
    let capitalizedString = ''

    inputStringArr.forEach((word) => {
      if (!word.startsWith('GLCP') && !word.startsWith('(')) {
        capitalizedString = `${capitalizedString} ${word}`
      }
    })

    return startCase(capitalizedString.trim())
  }

  return 'Sample Text'
}
